import { axInst, axInstBasic } from "../../components/Service/Service";

export const getVasTablesDetails = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-vas-tables-details`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getvascount = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}vas_count`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getvascountfmc = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}vas_count_fmc`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
